import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import ContactForm from '../forms/ContactForm';

const ContactSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-padding">
      <div className="container-custom grid lg:grid-cols-2 gap-8">
        <div className="glass-card p-8">
          <h2 className="text-3xl font-bold text-[#0f172a] mb-3">{t('contact.title')}</h2>
          <p className="text-[#475569] mb-6 text-lg">{t('contact.subtitle')}</p>
          <ul className="space-y-4 text-[#334155]">
            <li className="flex items-center gap-3"><MapPin size={18} className="text-sky-700" /> {t('contact.info.address')}</li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-sky-700" /> {t('contact.info.phone')}</li>
            <li className="flex items-center gap-3"><Mail size={18} className="text-sky-700" /> {t('contact.info.email')}</li>
          </ul>
        </div>
        <div className="glass-card p-8">
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
